import React, { useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, IconButton} from '@mui/material';
import { endOfDay, startOfDay } from 'date-fns'
import moment from 'moment';
import TableCell from '@mui/material/TableCell';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import Swal from "sweetalert2";

import appConfig from '../config/appConfig';
import SkeletonGridLoader from '../components/SkeletonGridLoader';
import DefaultTable from '../components/Table';
import * as optoutActions from '../store/actions/optout';
import * as menuActions from '../store/actions/breadcrumb';
import { CalculateUTCTzToUserTz,CalculateUserTzToUTCTz} from '../components/Utils';

const Optoutmanagement = ({optOutData, setBreadcrumb,fetchManageOptOutList,triggerOptIn}) => {

    const [pagination, setPagination] = useState({ limit: 10, offset: 1 });
    const [selectedDate, setSelectedDate] = useState({
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date())
  });
  const [channel, setChannel] = useState({key:"SMS", value:"sms"});

  const [searchText, setSearchText] = useState("");
  const [actionMade,setIsActionMade] = useState(false);


  
    const handlePagination = (limit, offset) => {
        setPagination({ limit, offset })
      }

      const onDateChange = (date) => {
        setSelectedDate({
            startDate: date?.[0]?.startDate || date?.startDate,
            endDate: date?.[0]?.endDate || date?.endDate
        });
    }

    const handleFilterChange = (filter) => {
      setSearchText('');
      setChannel(filter);
  }

  const handleSearch = (search) => {
    setSearchText(search);
}


    const enableOptIn = (row) =>{
        setIsActionMade(true);
        triggerOptIn(row,channel)
    }



    const filterValues = {
      filterBy:channel.value,
      startDate: CalculateUserTzToUTCTz(selectedDate?.startDate).toISOString(),
      endDate: CalculateUserTzToUTCTz(endOfDay(selectedDate?.endDate)).toISOString()
  }

  useEffect(() => {
    if (optOutData?.optoutUser?.data?.status === 1 && actionMade) {
        // setIsLoading(false);
        setIsActionMade(false);
        Swal.fire({
            icon: optOutData?.optoutUser?.data?.status === 1 ? "success" : "warning",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Opt In Success",
        });
        setTimeout(() => {
         fetchManageOptOutList(filterValues,searchText,pagination.limit, pagination.offset)
      }, 1000);
        
    } else if (optOutData?.optoutUser?.data?.status && optOutData?.optoutUser?.data?.status === 0) {
        // setIsLoading(false);
        setIsActionMade(false);
        Swal.fire({
            icon: "warning",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Please try again, later",
        });
        
    }
}, [JSON.stringify(JSON.stringify(optOutData?.optoutUser?.data))])


  const renderCells = (row) =>{
    return <>
    <TableCell sx={{fontFamily:appConfig.fontfamily,fontSize:appConfig.font16}}>{channel.key === 'Email' ? row.email : row.mobileNo}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.isOptIn ? 'No':'Yes'}</TableCell>
    </> 
  }

      useEffect(() => {
        setBreadcrumb('Opt Out Management')
        // fetchOptoutList(filterValues,searchText,pagination.limit, pagination.offset);
        fetchManageOptOutList(filterValues,searchText,pagination.limit, pagination.offset)
        console.log("funcs",fetchManageOptOutList,triggerOptIn)
      }, [ JSON.stringify(pagination),JSON.stringify(channel),JSON.stringify(selectedDate),searchText])

      const handleSort = (sortValue) => {
        console.log("sort",sortValue)
        }

          const renderActionButton = (row) => {
            
            return <div className='display-flex'>
                    {!row.isOptIn &&
                    <IconButton  sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} 
                        title='Opt In' aria-label="delete" size="small" onClick={()=>enableOptIn(row)}>
                       <HowToRegIcon sx={{fontSize: 24, borderRadius:"50%", color:appConfig.colors.darkblue}} />
                    </IconButton> }
            </div>
          }
        


    return <div>
        <Grid container spacing={2}>
        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
        <h1 className='page-heading' ><b>Opt Out Management</b></h1>
            <hr style={{border:"3px solid #EDF6F5", margin:"20px 0"}}/>
          </Grid>


        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
        {optOutData?.manageoptoutUser?.isLoading ? <SkeletonGridLoader /> :
        <DefaultTable
          title="Total"
          handlePagination={handlePagination}
          headers={[{name:channel.key === 'Email' ? 'Email' : 'Mobile', sortEnabled:false},{name:'Opted Out', sortEnabled:false}]}
          data={channel.key.toLowerCase() === "email" ? optOutData?.manageoptoutUser?.data : optOutData?.manageoptoutUser?.data}
          totalCount={optOutData?.manageoptoutUser?.data?.length}
          currentPage={pagination.offset}
          currentLimit={pagination.limit}
          isDateFilter
          selectedDateObj={(date)=>onDateChange(date)}
          dateFilterLabel={ `${moment(CalculateUTCTzToUserTz(selectedDate.startDate)).format('MM-DD-YYYY')} - ${moment(CalculateUTCTzToUserTz(selectedDate.endDate)).format('MM-DD-YYYY')}`}
          filterOptions={[{key:"SMS", value:"sms"},{key:"Email", value:"email"}]}
          isFilterEnabled
          filterAction={(filter)=>{handleFilterChange(filter)}}
          defaultFilter={channel}
          isSearchEnabled
          searchCallback={(text) => handleSearch(text)}
          searchKey={searchText}
          searchPlaceholderText= {channel.key === 'Email' ?  'Search by Email' : 'Search by mobile number'}
          renderCustomCells
          renderCells = {renderCells}
          hasAction
          renderActionButton={renderActionButton}
          // exportCallback={handleExport}
          isSortEnabled
          handleSort={handleSort}
        /> }
        </Grid>
        </Grid>
       
    </div>
}


Optoutmanagement.propTypes = {
    optOutData: PropTypes.objectOf(PropTypes.object).isRequired,
    // fetchOptoutList: PropTypes.func.isRequired,
    // exportOptoutList: PropTypes.func.isRequired,
    setBreadcrumb: PropTypes.func.isRequired,
    fetchManageOptOutList: PropTypes.func.isRequired,
    triggerOptIn: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({ optOutData: state.optout })

const mapDispatchToProps = (dispatch) => {
    return {
        // fetchOptoutList: (data,search,limit,page) => dispatch(optoutActions.fetchOptOutList(data,search,limit,page)),
        // exportOptoutList: (data,search) => dispatch(optoutActions.exportOptoutData(data,search)),
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
        fetchManageOptOutList:(data,search,limit,page)=>dispatch(optoutActions.fetchManageOptOutList(data,search,limit,page)),
        triggerOptIn:(data,channel)=>dispatch(optoutActions.triggerOptIn(data,channel)),
        
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Optoutmanagement);


